<template>
  <div>
    <p>
      This is the list of tasks that are created for this company via
      <b>Automated Configuration Service</b>
      .
    </p>
    <ts-spinner
      :data-visible="(tasks.length === 0 && loading) || null"
      data-size="medium"
      data-message="Loading your tasks..."
    />
    <div data-ts="Table" id="edifierTenantTasksTable" ref="table"></div>
    <div class="button-wrapper">
      <ts-tooltip
        tooltip="There is no more tasks to load"
        :disabled="!allLoaded"
      >
        <ts-button
          type="primary"
          v-if="tasks.length > 0"
          :busy="loading"
          @button-click="loadMore"
          :disabled="allLoaded"
        >
          Load More
        </ts-button>
      </ts-tooltip>
    </div>
  </div>
</template>

<script>
import { getEdifierTenantTasks } from '../../../../api';
import '@tradeshift/elements.spinner';
import '@tradeshift/elements.button';
import '@tradeshift/elements.tooltip';

export default {
  props: {
    tenantId: {
      type: String,
      required: true,
    },
  },
  emits: ['open-report'],
  data() {
    return {
      tasks: [],
      pageState: null,
      loading: false,
      allLoaded: false,
    };
  },
  mounted() {
    this.getEdifierTasks();
  },
  methods: {
    getEdifierTasks(isUpdating = false) {
      const $table = this.$refs.table;
      $table.setAttribute('data-ts.busy', 'Loading');
      this.loading = true;
      getEdifierTenantTasks(this.tenantId, {
        pageState: this.pageState,
      })
        .then((respData) => {
          this.pageState = respData.pageState;
          if (!respData.tasks || !this.pageState) {
            this.allLoaded = true;
          }

          this.tasks = [...this.tasks, ...respData.tasks];

          if (isUpdating) {
            this.loadTable(respData.tasks);
          } else {
            // set cols and reinitialize the table
            this.drawTable(respData.tasks);
          }
        })
        .finally(() => {
          $table.setAttribute('data-ts.busy', '');
          this.loading = false;
        });
    },
    getbutton(label, name, value) {
      return {
        item: 'Button',
        type: 'ts-secondary ts-micro',
        label,
        name,
        value,
      };
    },
    getTableCols() {
      return [
        {
          label: 'Created At',
          width: 180,
        },
        {
          label: 'Task Id',
        },
        {
          label: 'Label/Reason',
        },
        {
          label: 'Report',
          width: 115,
        },
      ];
    },
    getTableData() {
      return this.tasks.map((task) => [
        new Date(task.created_at).toLocaleString(),
        task.task_id,
        task.label,
        this.getbutton('View Report', 'report', task.task_id),
      ]);
    },

    drawTable(data) {
      ts.ui.get('#edifierTenantTasksTable', (table) => {
        table.cols(this.getTableCols());
        this.loadTable(data);
      });
    },
    loadTable() {
      ts.ui.get('#edifierTenantTasksTable', (table) => {
        table.rows(this.getTableData());
        table.onbutton = (name, value) =>
          this.tableButtonsClickHandler(name, value);
      });
    },
    tableButtonsClickHandler(name, value) {
      if (name === 'report') {
        this.$emit('open-report', value);
      }
    },
    loadMore() {
      this.getEdifierTasks(true);
    },
  },
};
</script>

<style>
.button-wrapper {
  display: flex;
  justify-content: center;
}
</style>
